import { DiffDOM } from "diff-dom";

export const HIGHLIGHT_ADDED = "diffDOM/highlightAdded";
export const HIGHLIGHT_REMOVED = "diffDOM/highlightRemoved";

export function highlightChanges(
    src: string,
    dst: string,
    highlight = HIGHLIGHT_ADDED
) {
    const srcDiv = document.createElement("div");
    const dstDiv = document.createElement("div");

    srcDiv.innerHTML = src;
    dstDiv.innerHTML = dst;

    const dd = new DiffDOM();
    const diff = dd.diff(srcDiv, dstDiv);
    dd.apply(dstDiv, diff);

    if (diff.length > 0) {
        for (const d of diff) {
            let target = dstDiv;
            for (const index of d.route) {
                // @ts-ignore
                target = target.childNodes[index];
            }

            const changed = document.createElement("span");
            changed.appendChild(target.cloneNode());

            if (highlight === HIGHLIGHT_ADDED) {
                changed.className = "__change-added";
            } else if (highlight === HIGHLIGHT_REMOVED) {
                changed.className = "__change-removed";
            }

            // @ts-ignore
            target.parentNode.replaceChild(changed, target);
        }
    }

    return dstDiv.innerHTML;
}
